import type { ScrapingIntentSummary } from '../types';
import { DateRangeSchema, SCRAPING_INTENT_MODE, SCRAPING_INTENT_SELECTOR_TYPE } from '../types';

import { z } from 'zod';

import { internalApiClient } from '@/shared/api-client/internal-api-client';
import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';

export const AdminCreateScrapingIntentRequestSchema = z.object({
  name: z.string().nullable().optional(),
  mode: z.enum(SCRAPING_INTENT_MODE),
  payload: z.object({
    platform: z.enum(SOURCE_PLATFORM_TYPE),
    selector: z.object({
      type: z.enum(SCRAPING_INTENT_SELECTOR_TYPE),
      keyword: z.string().optional(),
      urls: z.array(z.url()).optional(),
      exact_match: z.boolean().optional(),
    }),
    limit: z
      .object({
        item_per_day: z.number().int().min(1),
        date_range: DateRangeSchema.optional(),
      })
      .optional(),
    memo: z.string().nullable().optional(),
  }),
});

export type CreateScrapingIntentRequest = z.infer<typeof AdminCreateScrapingIntentRequestSchema>;

export async function createScrapingIntent(
  data: CreateScrapingIntentRequest,
): Promise<ScrapingIntentSummary> {
  const payload = AdminCreateScrapingIntentRequestSchema.parse(data);
  const response = await internalApiClient.post<ScrapingIntentSummary>('scraping-intents', {
    json: payload,
  });

  return response.json();
}
